<template>
  <div>
    <ul class="d-flex topCommon">
      <li class="d-flex">
        <img src="../../assets/zong.png" alt="" />
        <div class="rightDev">
          <!--span class="devTitle nomalFont">总碳排放量</span-->
          <span class="devTitle nomalFont">用电量</span>
          <span class="devNum nomalFont">{{ totalNum }}</span>
          <span class="devUnit nomalFont">kW.h</span>
          <!--span class="devUnit nomalFont">万tCO₂</span-->
        </div>
      </li>
      <li class="d-flex">
        <img src="../../assets/qiang.png" alt="" />
        <div class="rightDev">
          <!--span class="devTitle nomalFont">碳排放强度</span-->
          <span class="devTitle nomalFont">用水量</span>
          <span class="devNum nomalFont">{{ strengthNum }}</span>
          <span class="devUnit nomalFont">吨</span>
          <!--span class="devUnit nomalFont">tCO₂/万元</span-->
        </div>
      </li>
      <li class="d-flex">
        <img src="../../assets/lei.png" alt="" />
        <div class="rightDev">
          <!--span class="devTitle nomalFont">累计减排量</span-->
          <span class="devTitle nomalFont">用气量</span>
          <span class="devNum nomalFont">{{ reduceNum }}</span>
          <span class="devUnit nomalFont">立方米</span>
          <!--span class="devUnit nomalFont">万tCO₂</span-->
        </div>
      </li>
      <li class="d-flex">
        <img src="../../assets/moons.png" alt="" />
        <div class="rightDev">
          <!--span class="devTitle nomalFont">月碳排放量</span-->
          <span class="devTitle nomalFont">用汽量</span>
          <span class="devNum nomalFont">{{ moonsNum }}</span>
          <span class="devUnit nomalFont">吨</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "topCommon",
  props: {
    getTopCommonDatas: {
      type: Object,
      default: null
    }
  },
  watch: {
    getTopCommonDatas (curVal, oldVal) {
      if (curVal != null) {
        this.totalNum = (Number(this.getTopCommonDatas.allpaifangliang) / 10000).toFixed(2)
        this.strengthNum = Number(this.getTopCommonDatas.tanpaifangqiangdu).toFixed(2)
        this.moonsNum = (Number(this.getTopCommonDatas.monthpaifangliang) / 10000).toFixed(2)
        this.reduceNum = (Number(this.getTopCommonDatas.chanzhiniantongbi) / 10000).toFixed(2)
        // debugger
      }
    },
  },
  data () {
    return {
      totalNum: 0, //总碳排放量
      strengthNum: 0, //碳排放强度
      reduceNum: 0, //累计减排量
      moonsNum: 0, //月碳减排量
    }
  },
  created () {

  },
  methods: {


  },
  mounted () {
  }
}
</script>

<style scoped>
.topCommon {
  padding-top: 1rem;
  justify-content: space-between;
}
.topCommon li {
  padding: 0px 8px;
}
.topCommon img {
  max-width: 76px;
}
.topCommon .rightDev {
  padding-left: 10px;
}
.topCommon .devTitle {
  font-size: 18px;
  color: #fff;
  display: block;
  margin-bottom: 5px;
}
.topCommon .devNum {
  font-size: 32px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1.6px;
}
.topCommon .devUnit {
  font-size: 18px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/mid/topCommon.vue